<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ConditionsMixin extends Vue {
        get isLoading() {
            return runtimeStore.isConditionsLoading(this.offerKey)
        }

        get hasErrors() {
            return !this.conditionsInfo?.cancellationItems?.length
        }

        // TODO Same with hasErrors - wtf????
        get isFree() {
            return !this.conditionsInfo.cancellationItems.length
        }

        get isNonRefundable() {
            const firstCondition = this.conditionsInfo.cancellationItems[0]
            return (
                (firstCondition.dateFrom &&
                    firstCondition.price &&
                    new Date() >= this.$dateFns.parseISO(firstCondition.dateFrom) &&
                    this.$filters.convertPrice(this.price).amount <=
                        this.$filters.convertPrice(firstCondition.price).amount) ||
                this.offer?.rooms?.find(({groupedOffers}) =>
                    groupedOffers.map(({offerKey}) => offerKey).includes(this.offerKey)
                )?.nonRefundable ||
                this.offer?.offers?.find(({offerKey}) => offerKey === this.offerKey)?.nonRefundable
            )
        }

        get freeDate() {
            const firstCondition = this.conditionsInfo.cancellationItems[0]
            if (!firstCondition.dateFrom || new Date() >= this.$dateFns.parseISO(firstCondition.dateFrom)) {
                return undefined
            }
            return this.$dateFns.parse(firstCondition.dateFrom, 'yyyy-MM-dd HH:mm', new Date())
        }

        get status() {
            if (this.isLoading) {
                return 'isLoading'
            } else if (this.isOfferNonRefundable) {
                return 'isNonRefundable'
            } else if (this.hasErrors) {
                return 'hasErrors'
            } else if (this.isFree) {
                return 'isFree'
            } else if (this.isNonRefundable) {
                return 'isNonRefundable'
            } else if (this.freeDate) {
                return 'freeDate'
            } else {
                return 'special'
            }
        }

        get color() {
            switch (this.status) {
                case 'isLoading':
                    return 'text-black'
                case 'hasErrors':
                    return 'text-black'
                case 'isNonRefundable':
                    return 'text-red'
                case 'isFree':
                case 'freeDate':
                    return 'text-green'
                default:
                    return 'text-black'
            }
        }

        get label() {
            switch (this.status) {
                case 'isLoading':
                case 'hasErrors':
                    return this.$t('cancellation_policy')
                case 'isNonRefundable':
                    return this.$t('non_refundable')
                case 'isFree':
                    return this.isFreeLabel
                case 'freeDate':
                    return this.$t('free_cancellation_before_date', {
                        date: this.$filters.dateFormat(this.freeDate),
                    })
                default:
                    return this.$t('cancellation_policy')
            }
        }

        get isFreeLabel() {
            return this.$t('cancellation_free')
        }
    }

    export default ConditionsMixin
</script>
